module.exports = __webpack_public_path__ + "static/media/applyStudent.4c0f6ef7.xlsx";